import type { ChatbotLeadPayload, ChatbotLeadResponse } from './types'

export async function submitChatbotLead(
  payload: ChatbotLeadPayload
): Promise<ChatbotLeadResponse> {
  try {
    const res = await fetch('/api/chatbot/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    const data = (await res.json()) as ChatbotLeadResponse
    if (!res.ok) {
      return { ok: false, error: (data as { error?: string }).error ?? `HTTP ${res.status}` }
    }
    return data
  } catch (err) {
    return {
      ok: false,
      error: err instanceof Error ? err.message : 'Network error',
    }
  }
}
